import { iconFactory } from '../iconFactory'

export const BackArrow = iconFactory('BackArrow', ({ fill }) => (
  <polygon
    points="14.07 5 8.413 10.656 7 12.07 14.071 19.142 15.485 17.728 9.828 12.07 15.485 6.414 14.072 5"
    fill={fill}
  ></polygon>
))
